import React from 'react';

type Props = { step: 1 | 2 | 3 | 4 };

const TablyStepArt: React.FC<Props> = ({ step }) => {
  if (step === 1) {
    // Menu / admin panel mockup
    return (
      <svg viewBox="0 0 300 240" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Crear menú">
        <defs>
          <linearGradient id="g1" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#FFF3E8" />
            <stop offset="1" stopColor="#FFFAF5" />
          </linearGradient>
        </defs>
        <rect x="50" y="20" width="200" height="200" rx="18" fill="url(#g1)" />
        <rect x="50" y="20" width="200" height="36" rx="18" fill="#0E1116" />
        <rect x="50" y="38" width="200" height="18" fill="#0E1116" />
        <circle cx="66" cy="38" r="4" fill="#F43F5E" />
        <circle cx="80" cy="38" r="4" fill="#F5EADD" opacity="0.4" />
        <circle cx="94" cy="38" r="4" fill="#F5EADD" opacity="0.4" />
        <rect x="66" y="74" width="80" height="10" rx="3" fill="#0E1116" />
        <rect x="66" y="92" width="160" height="6" rx="2" fill="#0E1116" opacity="0.3" />
        <rect x="66" y="118" width="168" height="40" rx="8" fill="#FFF" stroke="#F5EADD" />
        <rect x="78" y="128" width="60" height="6" rx="2" fill="#0E1116" />
        <rect x="78" y="142" width="40" height="5" rx="2" fill="#0E1116" opacity="0.4" />
        <rect x="200" y="130" width="24" height="16" rx="4" fill="#F43F5E" />
        <rect x="66" y="170" width="168" height="40" rx="8" fill="#FFF" stroke="#F5EADD" />
        <rect x="78" y="180" width="70" height="6" rx="2" fill="#0E1116" />
        <rect x="78" y="194" width="44" height="5" rx="2" fill="#0E1116" opacity="0.4" />
        <rect x="200" y="182" width="24" height="16" rx="4" fill="#F43F5E" />
      </svg>
    );
  }

  if (step === 2) {
    // QR code with table label
    return (
      <svg viewBox="0 0 300 240" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Genera tu QR">
        <rect x="60" y="30" width="180" height="200" rx="14" fill="#FFFAF5" />
        <rect x="60" y="30" width="180" height="40" rx="14" fill="#F43F5E" />
        <rect x="60" y="56" width="180" height="14" fill="#F43F5E" />
        <text x="150" y="55" textAnchor="middle" fontFamily="Inter, sans-serif" fontWeight="700" fontSize="15" fill="#FFFAF5">MESA 12</text>
        {/* QR pattern */}
        <g fill="#0E1116" transform="translate(96 90)">
          {/* corners */}
          <rect x="0" y="0" width="28" height="28" rx="4" />
          <rect x="4" y="4" width="20" height="20" rx="2" fill="#FFFAF5" />
          <rect x="10" y="10" width="8" height="8" fill="#0E1116" />
          <rect x="80" y="0" width="28" height="28" rx="4" />
          <rect x="84" y="4" width="20" height="20" rx="2" fill="#FFFAF5" />
          <rect x="90" y="10" width="8" height="8" fill="#0E1116" />
          <rect x="0" y="80" width="28" height="28" rx="4" />
          <rect x="4" y="84" width="20" height="20" rx="2" fill="#FFFAF5" />
          <rect x="10" y="90" width="8" height="8" fill="#0E1116" />
          {/* data dots */}
          <rect x="36" y="4" width="6" height="6" />
          <rect x="48" y="4" width="6" height="6" />
          <rect x="36" y="16" width="6" height="6" />
          <rect x="60" y="16" width="6" height="6" />
          <rect x="36" y="36" width="6" height="6" />
          <rect x="48" y="36" width="6" height="6" />
          <rect x="60" y="36" width="6" height="6" />
          <rect x="72" y="36" width="6" height="6" />
          <rect x="84" y="36" width="6" height="6" />
          <rect x="36" y="48" width="6" height="6" />
          <rect x="60" y="48" width="6" height="6" />
          <rect x="84" y="48" width="6" height="6" />
          <rect x="36" y="60" width="6" height="6" />
          <rect x="48" y="60" width="6" height="6" />
          <rect x="72" y="60" width="6" height="6" />
          <rect x="84" y="60" width="6" height="6" />
          <rect x="36" y="72" width="6" height="6" />
          <rect x="60" y="72" width="6" height="6" />
          <rect x="36" y="84" width="6" height="6" />
          <rect x="48" y="84" width="6" height="6" />
          <rect x="60" y="84" width="6" height="6" />
          <rect x="72" y="84" width="6" height="6" />
          <rect x="84" y="84" width="6" height="6" />
          <rect x="36" y="96" width="6" height="6" />
          <rect x="60" y="96" width="6" height="6" />
          <rect x="84" y="96" width="6" height="6" />
        </g>
      </svg>
    );
  }

  if (step === 3) {
    // Phone scanning QR
    return (
      <svg viewBox="0 0 300 240" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Cliente escanea">
        {/* phone */}
        <rect x="95" y="20" width="110" height="200" rx="18" fill="#0E1116" />
        <rect x="100" y="25" width="100" height="190" rx="14" fill="#FFFAF5" />
        <rect x="135" y="30" width="30" height="5" rx="2.5" fill="#0E1116" />
        {/* viewfinder */}
        <rect x="115" y="60" width="70" height="80" rx="10" fill="#FFF3E8" />
        {/* corner brackets */}
        <path d="M120 70 L120 80 M120 70 L130 70" stroke="#F43F5E" strokeWidth="3" strokeLinecap="round" fill="none" />
        <path d="M180 70 L180 80 M180 70 L170 70" stroke="#F43F5E" strokeWidth="3" strokeLinecap="round" fill="none" />
        <path d="M120 130 L120 120 M120 130 L130 130" stroke="#F43F5E" strokeWidth="3" strokeLinecap="round" fill="none" />
        <path d="M180 130 L180 120 M180 130 L170 130" stroke="#F43F5E" strokeWidth="3" strokeLinecap="round" fill="none" />
        {/* mini QR in scanner */}
        <g fill="#0E1116" transform="translate(135 80)">
          <rect x="0" y="0" width="10" height="10" rx="1" />
          <rect x="20" y="0" width="10" height="10" rx="1" />
          <rect x="0" y="20" width="10" height="10" rx="1" />
          <rect x="14" y="14" width="4" height="4" />
          <rect x="20" y="20" width="4" height="4" />
          <rect x="26" y="20" width="4" height="4" />
          <rect x="20" y="26" width="4" height="4" />
        </g>
        {/* scan line */}
        <line x1="115" y1="100" x2="185" y2="100" stroke="#F43F5E" strokeWidth="2" opacity="0.8">
          <animate attributeName="y1" values="65;135;65" dur="2s" repeatCount="indefinite" />
          <animate attributeName="y2" values="65;135;65" dur="2s" repeatCount="indefinite" />
        </line>
        {/* text under */}
        <rect x="115" y="155" width="70" height="6" rx="2" fill="#0E1116" />
        <rect x="125" y="170" width="50" height="5" rx="2" fill="#0E1116" opacity="0.4" />
        <rect x="115" y="190" width="70" height="18" rx="6" fill="#F43F5E" />
      </svg>
    );
  }

  // step === 4 — Kitchen ticket / printer
  return (
    <svg viewBox="0 0 300 240" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Llega a cocina">
      {/* printer */}
      <rect x="60" y="40" width="180" height="60" rx="10" fill="#0E1116" />
      <rect x="70" y="50" width="160" height="14" rx="3" fill="#1F242C" />
      <circle cx="220" cy="80" r="5" fill="#F43F5E" />
      <circle cx="220" cy="80" r="5" fill="#F43F5E">
        <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" repeatCount="indefinite" />
      </circle>
      {/* paper coming out */}
      <rect x="80" y="98" width="140" height="130" rx="2" fill="#FFFAF5" />
      <path d="M80 228 L100 220 L120 228 L140 220 L160 228 L180 220 L200 228 L220 220" stroke="#0E1116" strokeWidth="0" fill="#FFFAF5" />
      <polygon points="80,228 100,220 120,228 140,220 160,228 180,220 200,228 220,220 220,228" fill="#FFFAF5" />
      {/* receipt content */}
      <rect x="92" y="108" width="64" height="8" rx="2" fill="#0E1116" />
      <rect x="92" y="122" width="40" height="5" rx="2" fill="#0E1116" opacity="0.5" />
      <line x1="92" y1="138" x2="208" y2="138" stroke="#0E1116" strokeWidth="1" strokeDasharray="3 3" opacity="0.4" />
      <rect x="92" y="148" width="80" height="6" rx="2" fill="#0E1116" />
      <rect x="184" y="148" width="24" height="6" rx="2" fill="#0E1116" />
      <rect x="92" y="162" width="70" height="6" rx="2" fill="#0E1116" />
      <rect x="184" y="162" width="24" height="6" rx="2" fill="#0E1116" />
      <rect x="92" y="176" width="74" height="6" rx="2" fill="#0E1116" />
      <rect x="184" y="176" width="24" height="6" rx="2" fill="#0E1116" />
      <line x1="92" y1="194" x2="208" y2="194" stroke="#0E1116" strokeWidth="1" strokeDasharray="3 3" opacity="0.4" />
      <rect x="92" y="204" width="50" height="8" rx="2" fill="#F43F5E" />
      <rect x="170" y="204" width="38" height="8" rx="2" fill="#F43F5E" />
    </svg>
  );
};

export default TablyStepArt;
